import { LoanChecklist, LoanChecklistRule } from 'src/services/loans/types';
import { create } from 'zustand';

interface LoanState {
  checklistState: 'new' | 'edit'; // Define the possible states for the checklist
  ruleState: 'new' | 'edit'; // Define the possible states for the rule
  currentChecklist: LoanChecklist;
  newChecklist: LoanChecklist;
  checklistSearchTerm: string; // Search term for filtering checklists
  ruleSearchTerm: string; // Search term for filtering rules
  currentChecklistRule: LoanChecklistRule;
  checklistStep: { id: number; name: string; href: string }[];
  loanChecklist: LoanChecklist[]; // Array of loan checklists
  setupLoading: boolean; // Loading state for setup
  actions: {
    setLoanChecklist: (checklists: LoanChecklist[]) => void; // Action to set loan checklists
    setSetupLoading: (loading: boolean) => void; // Action to set loading state
    setCurrentChecklist: (checklist: LoanChecklist) => void;
    setNewChecklist: (checklist: LoanChecklist) => void; // Action to set a new checklist
    setCurrentChecklistRule: (rule: LoanChecklistRule) => void;
    setChecklistState: (state: 'new' | 'edit') => void;
    setRuleState: (state: 'new' | 'edit') => void; // Action to set rule state
    setChecklistSearchTerm: (term: string) => void; // Action to set checklist search term
    setRuleSearchTerm: (term: string) => void; // Action to set rule search term
    setChecklistStep: (
      step: { id: number; name: string; href: string }[],
    ) => void;
  };
}

export const useLoanStore = create<LoanState>((set) => ({
  ruleState: 'new', // New is the default state for rules
  loanChecklist: [], // Initialize with an empty array
  setupLoading: false, // Initialize loading state
  checklistState: 'new', // New is the default state
  currentChecklist: {} as LoanChecklist, // Initialize with an empty object or a default value
  newChecklist: {} as LoanChecklist, // Initialize with an empty object or a default value
  currentChecklistRule: {} as LoanChecklistRule, // Initialize with an empty object or a default value
  checklistStep: [], // Initialize with an array of steps
  checklistSearchTerm: '', // Initialize with an empty string
  ruleSearchTerm: '', // Initialize with an empty string
  actions: {
    setRuleState: (state: 'new' | 'edit') => {
      set({ ruleState: state });
    },
    setLoanChecklist: (checklists: LoanChecklist[]) => {
      set({ loanChecklist: checklists });
    },
    setSetupLoading: (loading: boolean) => {
      set({ setupLoading: loading });
    },
    setCurrentChecklist: (checklist: LoanChecklist) => {
      set({ currentChecklist: checklist });
    },
    setCurrentChecklistRule: (rule: LoanChecklistRule) => {
      set({ currentChecklistRule: rule });
    },
    setChecklistState: (state: 'new' | 'edit') => {
      set({ checklistState: state });
    },
    setChecklistStep: (step: { id: number; name: string; href: string }[]) => {
      set({ checklistStep: step });
    },
    setChecklistSearchTerm: (term: string) => {
      set({ checklistSearchTerm: term });
    },
    setRuleSearchTerm: (term: string) => {
      set({ ruleSearchTerm: term });
    },
    setNewChecklist: (checklist: LoanChecklist) => {
      set({ newChecklist: checklist });
    },
  },
}));
